import React, { useState } from 'react';
import { User } from '@/types';
import { FeedPage } from '../feed/FeedPage';
import { ProfilePage } from '../profile/ProfilePage';
import O_HeaderResponsive from '@/components/O_Organisms/O_Header/O_HeaderResponsive';
import W_Loader from '@/components/W_Wrappers/W_Loader/W_Loader';
import { useInfiniteCapsulesFeed } from '@/hooks/useFeed';
import styles from './HomePage.module.css';

interface HomePageProps {
  user: User;
  onLogout: () => void;
}

export const HomePage: React.FC<HomePageProps> = ({ user, onLogout }) => {
  const [currentPage, setCurrentPage] = useState<'feed' | 'profile'>('feed');
  const [showLoader, setShowLoader] = useState(false);
  const { cards, isLoading, loadMore } = useInfiniteCapsulesFeed({
    userId: user.id,
    pageSize: 20,
  });

  React.useEffect(() => {
    if (currentPage === 'feed' && cards.length === 0 && isLoading) {
      setShowLoader(true);
    } else if (!isLoading) {
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [cards.length, isLoading, currentPage]);

  const handleBackToMain = () => {
    setCurrentPage('feed');
  };

  if (currentPage === 'feed' && showLoader) {
    return <W_Loader isLoading={isLoading && cards.length === 0} />;
  }

  return (
    <div className={styles.wrapper}>
      <O_HeaderResponsive />
      <main className={styles.content}>
        {currentPage === 'feed' ? (
          <FeedPage
            user={user}
            onLogout={onLogout}
            cards={cards}
            loadMore={loadMore}
          />
        ) : (
          <ProfilePage
            user={user}
            onLogout={onLogout}
            onBack={handleBackToMain}
          />
        )}
      </main>
    </div>
  );
};
